namespace ekh {
    class PhoneNumberInput {
        private countryCode: string;
        private countryCodeNumber: string;
        private ngModel: string = '';
        private exportValueToModel: string;
        private $countryPickerElement: JQuery;

        constructor(private $scope: ng.IScope,
                    private $element: JQuery
        ) {
            this.onInit();
            this.$scope.$on('$destroy', () => {
                this.onDestroy();
            });
        }

        onInit() {
            this.countryCode = this._getDefaultCountryCode();
            this.initCcPicker();

            this.$element.on('countrySelect', (e, data) => {
                this.onCountryCodeChange(data);
            });
            this.$countryPickerElement = angular.element('.cc-picker.cc-picker-code-select-enabled');
            this.$countryPickerElement.on('click', this.setTouched.bind(this));

            this.setCountryByCode(this.countryCode);
            this.$scope.$watch('phoneNumberCtrl.ngModel', this.updateExternalModel.bind(this));
            this.$scope.$watch('phoneNumberCtrl.exportValueToModel', this.syncExportValueModel.bind(this));
        }

        initCcPicker() {
            this.$element = this.$element.CcPicker({
                dataUrl: './build/country-phone-codes/data.json',
            });
        }

        setCountryByCode(countryCode) {
            this.$element.CcPicker('setCountryByCode', countryCode);
        }

        setCountryByPhoneCode(countryPhoneCode) {
            this.$element.CcPicker('setCountryByPhoneCode', countryPhoneCode);
        }

        setTouched() {
            this.$scope.ngModelCtrl.$setTouched();
        }

        onDestroy() {
            this.$element.off('countrySelect');
            this.$countryPickerElement.off('click');
        }

        onCountryCodeChange({code, phoneCode}) {
                this.countryCode = code;
                this.countryCodeNumber = phoneCode;
                this.updateExternalModel();
                this.$scope.$applyAsync(() => {
                    this.updateBooking();
            });
        }

        updateExternalModel() {
            this.exportValueToModel = `${this.countryCodeNumber} ${this.ngModel}`;
        }

        updateBooking() {
            if (this.$scope.ngModelCtrl && this.$scope.ngModelCtrl.$touched) {
                if (this.$scope.ngModelCtrl.$updateBooking) {
                    this.$scope.$evalAsync(this.$scope.ngModelCtrl.$updateBooking);
                }
            }
        }

        private _getDefaultCountryCode() {
            if (TRPCONFIG && TRPCONFIG.Domain && TRPCONFIG.Domain.CountryCode) {
                return TRPCONFIG.Domain.CountryCode;
            }
            return 'gb';
        }

        syncExportValueModel(value) {
            if (!value) {
                return false;
            }
            let [countryPhoneCode, phoneNumber] = value.split(' ');
            phoneNumber = !phoneNumber || phoneNumber === 'undefined' ? '' : phoneNumber;
            if (phoneNumber !== this.ngModel) {
                this.ngModel = phoneNumber;
            }
            if (countryPhoneCode !== this.countryCodeNumber) {
                this.countryCodeNumber = countryPhoneCode;
                this.setCountryByPhoneCode(this.countryCodeNumber);
            }
        }
    }

    angular
        .module('ekh')
        .directive('phoneNumberInput', () => {
            return {
                restrict: 'A',
                scope: {
                    exportValueToModel: '=',
                    ngModel: '='
                },
                require: ['ngModel'],
                bindToController: true,
                controller: PhoneNumberInput,
                controllerAs: 'phoneNumberCtrl',
                link: ($scope, $element, attr, ctrls) => {
                    $scope.ngModelCtrl = ctrls[0];
                }
            };
        });
}
